import React, {Component} from 'react';
import {dk_gray, dk_yellow} from "../constants/style";
import MaterialIcon from 'material-icons-react';
import connect from "react-redux/es/connect/connect";
import {connectedSelector, userSelector} from "../redux/reducers/authReducer";
import NavLink from "react-router-dom/es/NavLink";
import strings from "../screenLocalisation/account";

class Header extends Component {
    constructor(props){
        super(props)
        this.state = {
            dropDownVisible: false
        }
}

    render() {
        if(!this.props.connected) return null
        return (
            <div style={styles.container}>
                <div style={styles.userInfos}>
                    <div style={styles.userText}>
                        <p style={styles.userTextP}>{this.props.user.fullName}</p>
                        <p style={styles.userTextP}>{this.props.user.emailAddress}</p>
                    </div>
                    <NavLink to={'/'} >
                        <div style={styles.logo}>
                            <div style={styles.logoWrap}>
                                <MaterialIcon color={'white'} icon={'how_to_reg'} size={50}/>
                            </div>
                        </div>

                    </NavLink>
                </div>
            </div>
        );
    }
}

const styles = {
    container: {
        backgroundColor: dk_gray,
        position: 'absolute',
        right: 0,
        top: 0,
        padding: 5
    },
    userInfos: {
        display: 'inline-flex',
        flexDirection: 'row',
        alignItems: 'center'
    },
    logo: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%'
    },
    connectIcon: {

    },
    userText: {
        display: 'flex',
        flexDirection: 'column',
        justifyItems: 'space=around',
        padding: '0 20px'
    },
    logoWrap: {
        height: 50
    },
    userTextP: {
        color: 'white'
    }
}

const mapStateToProps = state => ({
    connected: connectedSelector(state),
    user: userSelector(state),
})

export default connect(mapStateToProps)(Header);